'use client'
import { useDevice } from '@lune-fe/lune-ui-lib'
import Box from '@mui/material/Box'
import Stack from '@mui/material/Stack'
import Text from '@mui/material/Typography'
import { BlogpostSlicedDocumentDataBodyQuoteSlice } from '@root/prismicio-types'
import Image from 'next/image'

import Profile from '@/components/Profile'

export const Quote = ({ slice }: { slice: BlogpostSlicedDocumentDataBodyQuoteSlice }) => {
    const { xsScreen } = useDevice()
    const {
        quote,
        author_name: authorName,
        author_role: authorRole,
        author_avatar: authorAvatar,
        quote_date: quoteDate,
    } = slice.primary
    return (
        <Box
            sx={{
                display: 'flex',
                flexDirection: 'column',
                alignItems: 'center',
            }}
        >
            <Stack
                direction="column"
                spacing={{
                    xs: 2,
                    sm: 4,
                    md: 4,
                    lg: 4,
                    xl: 4,
                }}
                sx={{
                    my: {
                        xs: 5,
                        sm: 15,
                        md: 15,
                        lg: 15,
                        xl: 15,
                    },
                    paddingLeft: 3,
                    borderLeft: 'solid 1px',
                    maxWidth: '720px',
                }}
            >
                <Text
                    variant={xsScreen ? 'h5' : 'h4'}
                    component="div"
                    sx={{
                        margin: '0 !important',
                    }}
                >
                    {quote}
                </Text>
                {authorName && (
                    <Profile
                        name={authorName}
                        title={authorRole!}
                        avatar={<Image fill={true} src={authorAvatar.url!} alt={authorName} />}
                        date={quoteDate!}
                    />
                )}
            </Stack>
        </Box>
    )
}
